import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cc from 'classcat';

import { themes } from '../../lib/themes';
import { createNotification } from '../../store/notifications/actions';
import Container from '../Container';

import styles from './styles.module.scss';

class Notification extends Component {
  static propTypes = {
    theme: PropTypes.oneOf(themes),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    fieldMessages: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
  };
  static defaultProps = {
    theme: 'waybetter',
  };
  static displayName = 'Notification';

  componentDidMount() {
    const { children, createNotification } = this.props;

    if (children) {
      createNotification({
        message: children,
      });
    }
  }

  render() {
    const { theme, message, fieldMessages, className, children } = this.props;

    if (children) return null;

    return (
      <Container
        outerClassName={cc([styles[theme], styles.container, className])}
        className={styles.content}
      >
        <div>{message}</div>
        {!!fieldMessages?.length && (
          <ul className={styles.fields}>
            {fieldMessages.map((m) => (
              <li key={m}>{m}</li>
            ))}
          </ul>
        )}
      </Container>
    );
  }
}

export default connect(null, { createNotification })(Notification);
